
























import { Vue, Component, Prop } from "vue-property-decorator";
import BaseComponent from "@/asdcom/BaseComponent";
import AttachmentComponent from "@/components/vcponlineok/staff-user/attachments/attachments-list-component.vue";
import { VcClaimChangeDto } from "@/asdcom/apiproxy/apiproxy.dto";

@Component({
  components: {
    AttachmentComponent
  }
})
export default class UpdatedClaimSectionListItem extends BaseComponent {
  @Prop({})
  // section: VcClaimChangeDto;
  section: any;
}
